import classNames from "classnames";
import React, { useEffect, useState } from "react";
import styles from "./../styles.module.scss";
import LeftNav from "../left-nav";
import TabsComponent from "@components/tabs";
import AssetModelList from "./assetModelList";
// import CreateModal from "./Form/createModal";
import CreateModal from "./Form/createProject";
import { DataSourceHandler } from "@api/data-source-handler";
import { useSelector } from "react-redux";
import { RootState } from "@store/types";
import { errorAlert } from "@components/toastify/notify-toast";
import { InstanceList, ModelList, ProjectData } from "./types";
import { InPageSpinner } from "@components/spinners/in-page-spinner";
import { Flex } from "@components/ui/Flex";
import CreateInstances from "./Form/createInstance";
import AssetInstancesList from "./assetInstancesList";
import { ShowWhenTrue } from "@helpers/showwhentrue";
import { BsArrowLeft } from "react-icons/bs";
import { Text } from "@components/ui/Text";
import { Select } from "antd";
import { isEmpty } from "lodash";
import DynamicLeftNav from "../left-nav";
import { TooltipTop } from "@components/tooltips";
import ClassProjectHierarchy from "./classProjectHierarchy";

const AssetHierarchy: React.FC = () => {
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [createActiveTab, setCreateActiveTab] = useState('details');
  const [selectedAsset, setSelectedAsset] = useState<InstanceList | null>(null);
  const [selectedModelAsset, setSelectedModelAsset] = useState<ModelList | null>(null);
  const [instanceType, setInstanceType] = useState('SINGLE_INSTANCE');
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState('add');
  const [modelList, setModelList] = useState<ModelList[]>([]);
  const [InstancesList, setInstancesList] = useState<InstanceList[]>([]);
  const [filterInstanceList, setFilterInstanceList] = useState<InstanceList[]>([]);
  const [createInstanceVisible, setCreateInstanceVisible] = useState(false);
  const [createActiveInstanceTab, setCreateActiveInstanceTab] = useState('details');
  const { envVariables: Env } = useSelector((store: RootState) => store.AccountReducer);
  const [projectData, setProjectData] = useState({} as ProjectData);
  const handleCreateTabChange = (key: string) => {
    setCreateActiveTab(key);
  };

  const handleCreateInstanceTabChange = (key: string) => {
    setCreateActiveInstanceTab(key);
  };

  const handleCancel = () => {
    setCreateModalVisible(false);
    setCreateActiveTab('details');
  };

  const handleInstanceCancel = () => {
    setCreateInstanceVisible(false);
    setCreateActiveInstanceTab('details');
  };

  const callModelList = () => {
    DataSourceHandler.getModelList(
      `${Env?.REACT_APP_PLATFORM_URL}/asset/api`,
      (response: any) => {
        if (response) {
          setModelList(isEmpty(response) ? [] : response);
          setLoading(false);
        } else {
          console.error("Unexpected response format or error", response);
          errorAlert("Failed to fetch patch data. Please try again.");
        }
      }
    );
  }

  const callProjectList = () => {
    DataSourceHandler.fetchProjectDetails(
      `${Env?.REACT_APP_PLATFORM_URL}/asset/api`,
      (response: any) => {
        if (response) {
          setModelList(isEmpty(response) ? [] : response);
          setLoading(false);
        } else {
          console.error("Unexpected response format or error", response);
          errorAlert("Failed to fetch patch data. Please try again.");
        }
      }
    );
  }

  const callInstancesList = () => {
    DataSourceHandler.getInstancesList(
      `${Env?.REACT_APP_PLATFORM_URL}/asset/api`,
      (response: any) => {
        if (response) {
          setInstancesList(response);
          setFilterInstanceList(response.filter((item: InstanceList) => item.instanceType === instanceType));
          setLoading(false);
        } else {
          console.error("Unexpected response format or error", response);
          errorAlert("Failed to fetch patch data. Please try again.");
        }
      }
    );
  }

  useEffect(() => {
    if (!isEmpty(Env)) {
      setLoading(true);
      // callModelList();
      callProjectList();
      // callInstancesList();
    }
  }, [Env])

  const tabItems = [
    {
      label: 'Projects',
      key: 'modals',
      children: (
        <div>
          <ShowWhenTrue show={!createModalVisible}>
            <button
              className={classNames(
                "btn-lg btn-yellow-transparent",
                styles["center"],
                styles["btn-lg"]
              )}
              onClick={() => {
                setType('add');
                setCreateActiveTab('details');
                setCreateModalVisible(true)
              }}
            >
              <img src="/icons/workflow/add.svg" alt="" />
              <span> Project </span>
            </button>
          </ShowWhenTrue>
          <ShowWhenTrue show={createModalVisible} >
            {/* <Flex flexDirection={"row"} alignItems={"center"} gap="10px" style={{ cursor: 'pointer', width: 160 }} onClick={() => {
              setCreateActiveTab('details');
              setCreateModalVisible(false)
            }}><BsArrowLeft /><Text>Back To Listing</Text></Flex> */}
            <button
              className="btn btn-yellow btn-sm"
              onClick={() => {
                setCreateActiveTab('details');
                setCreateModalVisible(false)
              }}
            >
              <Flex gap={"5px"} alignItems={"center"}>
                <BsArrowLeft />
                <span>Back</span>
              </Flex>
            </button>
            <div>
              <CreateModal
                type={type}
                activeTab={createActiveTab}
                onCancel={handleCancel}
                onTabChange={handleCreateTabChange}
                modelList={modelList}
                refreshModelList={callProjectList}
                selectedAsset={selectedModelAsset}
              />
            </div>
          </ShowWhenTrue>
          <ShowWhenTrue show={!createModalVisible} >
            {!loading ? <AssetModelList setType={setType} createModalVisible={createModalVisible} setCreateModelVisible={setCreateModalVisible} setSelectedAsset={setSelectedModelAsset} data={modelList} callModelList={callProjectList} setProjectData={setProjectData} /> : <Flex className="center"><InPageSpinner /></Flex>}
          </ShowWhenTrue>
        </div>
      ),
    },
    // {
    //   label: 'Instances',
    //   key: 'instances',
    //   children: <div>
    //     <ShowWhenTrue show={!createInstanceVisible}>
    //       <Flex gap="20px">
    //         <button
    //           className={classNames(
    //             "btn-lg btn-yellow-transparent",
    //             styles["center"],
    //             styles["btn-lg"]
    //           )}
    //           onClick={() => { setType('add'); setCreateActiveInstanceTab('details'); setCreateInstanceVisible(true) }}
    //         >
    //           <img src="/icons/workflow/add.svg" alt="" />
    //           <span> Instance </span>
    //         </button>
    //         <Select
    //           value={instanceType}
    //           onChange={(value) => {
    //             const filterInstanceList = InstancesList?.filter((item) => item.instanceType === value);
    //             setFilterInstanceList(filterInstanceList);
    //             setInstanceType(value);
    //           }}
    //           style={{ width: 210, marginRight: 12 }}
    //           className={'attributes-table-select'}
    //         >
    //           <Select.Option value="SINGLE_INSTANCE">SINGLE_INSTANCE</Select.Option>
    //           <Select.Option value="MULTIPLE_INSTANCE">MULTIPLE_INSTANCE</Select.Option>
    //         </Select>
    //       </Flex>
    //     </ShowWhenTrue>
    //     <ShowWhenTrue show={createInstanceVisible} >
    //       <Flex flexDirection={"row"} alignItems={"center"} gap="10px" style={{ cursor: 'pointer', width: 160 }} onClick={() => { setCreateActiveInstanceTab("details"); setCreateInstanceVisible(false) }}><BsArrowLeft /><Text>Back To Listing</Text></Flex>
    //       <div>
    //         <CreateInstances
    //           type={type}
    //           activeTab={createActiveInstanceTab}
    //           onCancel={handleInstanceCancel}
    //           onTabChange={handleCreateInstanceTabChange}
    //           modelList={modelList}
    //           refreshModelList={callInstancesList}
    //           selectedAsset={selectedAsset}
    //         />
    //       </div>
    //     </ShowWhenTrue>
    //     <ShowWhenTrue show={!createInstanceVisible} >
    //       {!loading ? <AssetInstancesList instanceType={instanceType} setType={setType} createInstanceVisible={createInstanceVisible} setCreateInstanceVisible={setCreateInstanceVisible} setSelectedAsset={setSelectedAsset} modelList={modelList} data={filterInstanceList} callModelList={callInstancesList} /> : <Flex className="center"><InPageSpinner /></Flex>}
    //     </ShowWhenTrue>
    //   </div>,
    // },
  ];

  return (
    <section className={classNames(styles['admin__container'])}>
      <DynamicLeftNav selected_id="project-asset" type="others" />
      <div className={styles['nifi_content']}>
        <header>
          <h1>
            <img src="/icons/asset-hierarchy.svg" alt="" />
            Projects
          </h1>
        </header>

        <ShowWhenTrue show={isEmpty(projectData)}>
          <TabsComponent items={tabItems} onTabChange={() => { const temp = {} }} size="large" />
        </ShowWhenTrue>

        <ShowWhenTrue show={!isEmpty(projectData)}>
          <button
            className="btn btn-yellow btn-sm"
            onClick={() => setProjectData({} as ProjectData)}
          >
            <Flex gap={"5px"} alignItems={"center"}>
              <BsArrowLeft />
              <span>Back</span>
            </Flex>
          </button>
          <ClassProjectHierarchy project={projectData} />
        </ShowWhenTrue>
      </div>
    </section>

  );
};

export default AssetHierarchy;
